// Electric and aviation-gas craft (#32): your aircraft burn battery or fuel
// as they fly and refill only at a base that supplies their kind (stepOps
// does the burning and refilling). This keeps watch: an aircraft that won't
// make it back to base needs an emergency landing; one that runs dry comes
// down in a field; one parked low where it can't refill is stranded until
// it's flown to the right hub or the ground crew trucks a supply out.
// Pure, no DOM.

import {
  HUBS, POWER, STRANDED_BELOW, ENERGY_RESERVE,
} from '../config/constants.js';
import { dist } from './geometry.js';
import { opsType, isAirborne } from './ops.js';
import { raiseEmergency, forceDown } from './zones.js';
import { clear as clearAlert } from './alerts.js';

const MARGIN = 3; // seconds of slack before warning that it won't make it home

export const suppliedAt = (a) => a.hubIdx !== null && HUBS[a.hubIdx].supplies.includes(a.power);

function strandedAlert(s, a) {
  return s.alerts.list.find((x) => x.kind === 'stranded' && x.craftId === a.id) ?? null;
}

export function stepEnergy(s) {
  if (!s.ops || !s.running) return;
  for (const a of s.ops.aircraft) {
    if (a.energy < 0.5) s.alerts.notes.add('power');
    const t = opsType(a.type);
    if (isAirborne(a)) {
      if (a.energy <= 0) {
        forceDown(s, a, `${a.call} ran out of ${POWER[a.power].unit}`);
        continue;
      }
      // won't make it back to base: land somewhere now
      const timeLeft = a.energy * t.endurance;
      const timeHome = dist(a, a.home) / t.speed;
      if (!a.emergency && timeLeft < timeHome + MARGIN) {
        raiseEmergency(s, a, `its ${POWER[a.power].unit} won't last back to ${a.padName}`);
      }
    }
    // parked low where it can't refill: stranded
    const stuck = !isAirborne(a) && !suppliedAt(a) && a.energy < STRANDED_BELOW;
    const alert = strandedAlert(s, a);
    if (stuck && !alert) {
      s.alerts.list.push({
        id: s.alerts.seq++, kind: 'stranded', left: null, fieldIdx: null, hubIdx: null,
        craftId: a.id, call: a.call, base: a.padName, power: POWER[a.power].name, x: a.x, y: a.y,
      });
      s.alerts.notes.add('stranded');
    } else if (!stuck && alert) clearAlert(s, alert, false);
  }
}

/** Short readout, e.g. "⚡ 64%" or "⛽ 80%". */
export const energyText = (a) => `${POWER[a.power].icon} ${Math.round(a.energy * 100)}%`;

/** Whether a trip leaves enough in hand (used by previews). */
export const hasReserve = (a, need) => need + ENERGY_RESERVE <= a.energy;
